module.exports = __webpack_public_path__ + "media/images/flags/KR-73b6865d707c83f6421ae84e4d02b44a.svg";